import Spin from 'antd/lib/spin'
require('antd/lib/spin/style')

export default Spin
